import React from "react";
import { useTranslation } from "react-i18next";
import "./Alerts.css";

const AlertsCustom = ({ type, title, message, onClose }) => {
    const { t } = useTranslation('common');
    return (
        <div className="back">
            <div className={`alert alert-${type}`}>
                <span className={`alert-title-${type}`}>{title}</span>
                <span className="alert-message">{message}</span>
                <button className="alert-close" data-testid="alert-close-button" onClick={onClose}>{t('alertOk')}</button>
            </div>
        </div>
    );
};

export default AlertsCustom;